import { Inject, Injectable } from '@angular/core';
import { ErrorHandlerService } from '@y42/error-handling';
import { getY42GitPath, Y42GitFolders } from '@y42/feature/git';
import { AbstractGitService, GitParentFolders, GIT_PARENT_FOLDERS } from '@y42/feature/git/state';
import { Y42MetadataGitModel } from '@y42/feature/json-schema';
import { GitQuery, GitService } from '@y42/git';
import { VisualizationTabStoreModel } from './visualization-tab.model';

@Injectable()
export class VisualizationTabGitService extends AbstractGitService<
  VisualizationTabStoreModel,
  Y42GitFolders.VisualizationDashboard
> {
  constructor(
    protected readonly git: GitService,
    protected readonly gitQuery: GitQuery,
    protected readonly errorHandlerService: ErrorHandlerService,
    @Inject(GIT_PARENT_FOLDERS) protected readonly parentFolders: GitParentFolders,
  ) {
    super({
      gitQuery,
      git,
      name: 'Visualization-Tab-Git',
      basePath: getY42GitPath(Y42GitFolders.VisualizationDashboard),
      errorHandlerService,
      models: {
        metadata: {
          fileName: 'metadata.json',
          model: Y42MetadataGitModel,
        },
      },
      parentFolders,
    });
  }

  async create(tab: VisualizationTabStoreModel) {
    const id = tab.$name;
    await this.git.createFolder(this.getPath(id), { skipSync: true });
    await this.git.createFolder(this.getPath(id, 'canvas'), { skipSync: true });
    await this.git.writeFile({
      path: this.getPath(id, this.cfg.models!.metadata.fileName),
      content: new Y42MetadataGitModel(tab),
    });
  }

  async update(tab: VisualizationTabStoreModel) {
    const id = tab.$name;
    const path = this.getPath(id, this.cfg.models!.metadata.fileName);
    await this.git.writeFile({
      path,
      content: new Y42MetadataGitModel(tab),
    });
  }

  async delete(id: VisualizationTabStoreModel['$name']) {
    const path = this.getPath(id);
    return await this.git.deleteDirectory(path);
  }
}
